import styled, { css } from 'styled-components'
import AiGlyph from '../../../../assets/icons/ai-glyph.svg'

type Size = 'small' | 'medium'

const avatarSizeMap = {
    small: (theme: any) => theme.typography.font.size.medium,
    medium: (theme: any) => theme.layout.xSmall,
}

const glyphSizeMap = {
    small: (theme: any) => theme.typography.font.size.xxxSmall,
    medium: (theme: any) => theme.typography.font.size.xSmall,
}

export const Avatar = styled.span<{ $size: Size }>(
    ({ theme, $size }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: ${avatarSizeMap[$size](theme)};
        height: ${avatarSizeMap[$size](theme)};
        border-radius: 50%;
        background: linear-gradient(153deg, ${theme.colors.tfwViolet} 52.64%, #9876ce 121.74%);
        filter: drop-shadow(0 0 7px rgba(163, 107, 247, 0.5));
    `,
)

export const AvatarGlyph = styled(AiGlyph)<{ $size: Size }>(
    ({ theme, $size }) => css`
        width: ${glyphSizeMap[$size](theme)};
        height: ${glyphSizeMap[$size](theme)};

        /* A global \`*\` rule sets color on every element, including <path>, which beats inheriting
           from this svg — so currentColor resolves to the body text colour. Set fill directly. */
        path {
            fill: ${theme.colors.white};
        }
    `,
)
